<div class="row">
  <div class="col-md-12 popin-container space-between">
    <div class="customerBox">
      <mat-icon class="icon valign-customer" matTooltip="Société" matSuffix>apartment</mat-icon>
      <strong class="customerIdentity">{{ customerName }}</strong>
      <a routerLink="/{{ visitRandomId }}/{{ uri }}/edit" class="float-right"><strong>Ce n'est pas moi</strong></a><br>
      {{ customerActivity }} à {{ customerCity }}
    </div>
    <div class="text-center">
      <h3>Merci <strong>{{ customerName }}</strong>, en quoi pouvons nous vous aider aujourd'hui ?</h3>
    </div>
    <div class="buttonsBox">
      <a routerLink="technique?visitRandomId={{ visitRandomId }}"><button type="button" class="btn btn-primary m-2">Support technique</button></a>
      <a routerLink="commerciale?visitRandomId={{ visitRandomId }}"><button type="button" class="btn btn-primary m-2">Information commerciale</button></a>
      <a routerLink="administrative?visitRandomId={{ visitRandomId }}"><button type="button" class="btn btn-primary m-2">Contact administratif</button></a>
    </div>
    <div class="text-center">
      <a routerLink="/exit-popin?visitRandomId={{ visitRandomId }}"><strong>Laissez moi découvrir le site</strong></a>
    </div>
  </div>
</div>
